<template>
  <div>
    <me />
    <device />
    <malls />
    <contract />
    <loading-success v-if="isLoadingSuccess" />
  </div>
</template>

<script>
import Me from './Me.vue'
import Malls from './Malls.vue'
import Device from './Device.vue'
import Contract from './Contract.vue'
import LoadingSuccess from './LoadingSuccess.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Me,
    Malls,
    Device,
    Contract,
    LoadingSuccess,
  },
  computed: {
    ...mapState('auth', ['isMeLoad']),
    ...mapState('contract', ['isContractsLoad']),
    ...mapState('mall', ['isMallsLoad']),
    // status 전체 완료
    isLoadingSuccess() {
      return this.isMeLoad && this.isContractsLoad && this.isMallsLoad
    },
  },
}
</script>
